module.exports = __webpack_public_path__ + "img/lsm-app-icon.b5901b84.png";